import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CompanyOverview from './components/CompanyOverview';
import ProductPortfolio from './components/ProductPortfolio';
import KeyCapabilities from './components/KeyCapabilities';
import OurPartnerExport from './components/OurPartnerExport';
import Footer from './components/Footer';
import Contact from './components/Contact';
import PatentPage from './components/PatentPage';

function App() {
  return (
    <>
    <Navbar></Navbar>
    <HeroSection></HeroSection>
    <CompanyOverview></CompanyOverview>
    <ProductPortfolio></ProductPortfolio>
    <KeyCapabilities></KeyCapabilities>
    <PatentPage></PatentPage>
    <OurPartnerExport></OurPartnerExport>
    <Contact></Contact>
    <Footer></Footer>
    </>
  );
}

export default App;
